<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex mu-flex-column mu-w-100 mu-gap-04">
            <div class="mcc-row">
                <section class="mcc-col mu-d-flex mu-flex-row">

                    <h1>{{ title }}</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">

                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
                </section>
                <section class="mcc-col mu-d-flex mu-justify-content-end mu-align-items-center">

                    <div role="group" class="mcc-button-group">
                        <button class="mcc-button mcc-button--primary" id="addTemplateBtn" @click="redirectToCreateEmailTemplate()" :title="addBtnTxt">
                            <mcc-icon name="plus" aria-hidden="true"></mcc-icon><span class="mcc-button__label">{{ addBtnTxt }}</span>
                        </button>

                    </div>

                </section>

                <div>
                </div>
            </div>
        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <nav aria-label="breadcrumb">
            <ol class="mcc-breadcrumb">
                <li>Design</li>
                <li>{{ title }}</li>

            </ol>
        </nav>

        <Drawer ref="customFilter" @reset-filter="resetFilter" @apply-filter="applyFilter()" :title="filterTitle">

            <div class="mcc-row">
                <div class="mcc-col">
                    <form id="formIdd">

                    <div class="mfc-input-wrapper mfc-form-input-container drawer-input">
                        <label for="name">Name</label>
                        <input type="text" name="form-name" maxlength="50" id="name" :pattern="nameRegex" :value="templateListNameRef" @change="templateListNameRef = $event.target.value">

                    </div>
                    <div class="mfc-slim-select-wrapper drawer-input">
                        <label for="createdby-selectId">Created by</label>
                        <select @change="selectedCreatedByRef = $event.target.value" ref="createdByRef" name="createdby-select" id="createdby-selectId" no-deselect="false" block label="Created by">
                            <option data-placeholder="true" value=""></option>
                            <option v-for="(app, key) in userList" :selected="selectedCreatedByRef === app.username" :key="key" :value="app.username">{{ app.firstName }}</option>
                        </select>
                    </div>
                    <div class="mfc-slim-select-wrapper drawer-input">
                        <label for="updatedby-selectId">Last updated by</label>
                        <select @change="selectedUpdatedByRef = $event.target.value" ref="updatedByRef" name="updatedby-select" id="updatedby-selectId" block>
                            <option data-placeholder="true" value=""></option>
                            <option v-for="(app, key) in userList" :selected="selectedUpdatedByRef === app.username" :key="key" :value="app.username">{{ app.firstName }}</option>
                        </select>
                    </div>
                </form>
                </div>

            </div>

        </Drawer>

        <div class="mcc-col">
            <div style="position:relative">
                <div v-if="!updateCall" class="spinner-overlay">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>

                <div class="mcc-card">
                    <div class="mcc-card__body">
                        <div class="mu-d-flex mu-justify-content-end mu-pb-06">
                            <button class="mcc-button mcc-button--outline  mcc-button--sm" @click="$refs.customFilter.open()">
                                <mcc-icon name="filter" aria-hidden="true"></mcc-icon>
                                <span class="mcc-button__label">Filters {{ filterCount > 0 ? '(' + filterCount + ')' : '' }}</span>
                            </button>
                        </div>
                        <mcc-data-table ref="templateTable" id="templateTableId"></mcc-data-table>
                    </div>
                </div>

            </div>

        </div>

    </div>
</div>
</template>

<script>
import constantMessages from "../../../messages";
import TemplateAPI from "../../../services/TemplateAPI";
import Utils from "@/script_utils";
import MyProcessListAPI from "../../../services/MyProcessListAPI";
import Drawer from '../../common/Drawer.vue';
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';

export default {
    name: "TemplateList",
    components: {
        Drawer
    },
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["formtemplates.list"],
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            tableObj: null,
            currentPageSize: 10,
            updateCall: true,
            isEmailTemplate: false,
            title: "Form templates",
            addBtnTxt: "Add form template",
            filterTitle: "Form template Filters",
            templateType: "FORM",
            updateDialog: false,
            userList: [],
            nameRegex: constantMessages.PATTERNS["name"],
            templateListName: "",
            templateListNameRef: "",
            selectedCreatedByRef: "",
            selectedUpdatedByRef: "",
            selectedCreatedBy: "",
            selectedUpdatedBy: "",
            createdbyselectInstance: null,
            updatedbyselectInstance: null,
            filterActive: false,
            filterData: [],
            tableData: [],
            filterCount: 0,

        };
    },
    created() {
        this.isEmailTemplate = this.$route.name == "EmailTemplates";
        if (this.isEmailTemplate) {
            this.title = "Email templates";
            this.addBtnTxt = "Add email template"
            this.filterTitle = "Email template Filters"
            this.helpText = constantMessages.BREADCRUMB_HELP["emailtemplates.list"]
            this.templateType = "EMAIL";
        }
    },
    mounted() {
        let self = this
        Utils.applyFixedHeaderConfiguration(this);

        if (localStorage.getItem("emailTemplateList") === "emailTemplateList") {
            var pageSizeRef = localStorage.getItem("EmailTemplateListPageSize");

            if (pageSizeRef != null && pageSizeRef != "") {
                this.currentPageSize = parseInt(pageSizeRef);
            }
            localStorage.removeItem("EmailTemplateListPageSize");
            localStorage.removeItem("emailTemplateList");

            this.selectedCreatedBy = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_selectedCreatedBy"
            );
            if (this.selectedCreatedBy == null) {
                this.selectedCreatedBy = ""
            }
            this.selectedCreatedByRef = this.selectedCreatedBy;
            this.selectedUpdatedBy = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_selectedUpdatedBy"
            );
            if (this.selectedUpdatedBy == null) {
                this.selectedUpdatedBy = ""
            }
            this.selectedUpdatedByRef = this.selectedUpdatedBy;

            this.templateListName = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_dataListName"
            );

            if (this.templateListName == null) {
                this.templateListName = "";
            }
            this.templateListNameRef = this.templateListName;
        }

        MyProcessListAPI.getUsers().then(result => {
            this.userList = result;
            self.createdbyselectInstance = new SlimSelect({
                select: '#createdby-selectId',

            })
            self.updatedbyselectInstance = new SlimSelect({
                select: '#updatedby-selectId',

            })
        });

        self.initTemplateTable();

    },
    methods: {
        resetSlimSelect() {
            this.createdbyselectInstance.setSelected('')
            this.updatedbyselectInstance.setSelected('')
        },
        getFilterCount() {
            if (this.templateListNameRef != "")
                this.filterCount += 1
            if (this.selectedCreatedByRef != "")
                this.filterCount += 1
            if (this.selectedUpdatedByRef != "")
                this.filterCount += 1

        },
        applyFilter() {
            let form = $('#formIdd')
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            this.selectedCreatedBy = this.selectedCreatedByRef;
            this.selectedUpdatedBy = this.selectedUpdatedByRef;
            this.templateListName = this.templateListNameRef;
            this.filterCount = 0;
            this.getFilterCount();
            this.initTemplateTable();
            $('#formIdd').closest('#drawerOverlay').removeClass("mcc-drawer--open")
            $('#formIdd').closest('#drawerOverlay').addClass("mcc-drawer--closed")
        },

        updateTemplate() {
            var self = this;
            this.$refs.templateTable
                .querySelectorAll('td [class="name-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        self.setFilterDataInLocalStorage();
                        var targetEle = e.target;
                        if (targetEle != null) {
                            var reference = $(targetEle).attr("data-id");
                            self.$router.push(
                                self.templateType == "EMAIL" ? self.CONTEXT_PATH + "/design/emailTemplates/" + reference.trim() : self.CONTEXT_PATH + "/design/formTemplates/" + reference.trim()
                            );
                        }
                    });
                });
        },
        initTemplateTable() {
            var self = this;
            if (self.tableObj != null) {
                self.currentPageSize = self.tableObj.tableContext.store.state.pageSize;
            }
            const table = document.getElementById("templateTableId");
            self.tableObj = window.tableFactory.create(table, {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No templates found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                fixedHeight: true,
                pageSize: self.currentPageSize,
                debounceTime: 1000,
                schema: {
                    properties: {
                        name: {
                            type: "string",
                            title: "Name",
                            sortable: true,
                            template: '<a class="name-link" data-id="{{id}}">{{name}}</a>',
                            columnSearch: false
                        },
                        created: {
                            type: "string",
                            title: "Created",
                            sortable: true,
                            template: '<div class="dateTemplate"><u>{{prettyCreatedTime}}</u><div>{{createdString}}</div></div>',
                            columnSearch: false
                        },
                        createdBy: {
                            type: "string",
                            title: "Created by",
                            sortable: true,
                            columnSearch: false
                        },
                        lastUpdated: {
                            type: "string",
                            title: "Last updated",
                            template: '<div class="dateTemplate"><u>{{prettyLastUpdatedTime}}</u><div>{{lastUpdatedString}}</div></div>',
                            sortable: true,
                            columnSearch: false
                        },
                        lastUpdatedBy: {
                            type: "string",
                            title: "Last updated by",
                            sortable: true,
                            columnSearch: false
                        }
                    }
                },
                data: (
                    start,
                    limit,
                    sortHeader,
                    sortDirection,
                    fullTextQuery,
                    searchColumns
                ) => {
                    if (!self.filterActive) {
                        self.updateCall = false;
                        if (self.tableObj != null) {
                            self.currentPageSize =
                                self.tableObj.tableContext.store.state.pageSize;
                        }
                        var sortHeaderData = sortHeader == null ? "name" : sortHeader;
                        var sortDir = sortDirection == null ? "" : sortDirection;
                        var queryString =
                            "start=" +
                            start +
                            "&length=" +
                            self.currentPageSize +
                            "&sort=" +
                            sortHeaderData +
                            "&dir=" +
                            sortDir +
                            "&name=" +
                            self.templateListName +
                            "&createdBy=" +
                            self.selectedCreatedBy + "&updatedBy=" + self.selectedUpdatedBy;

                        return TemplateAPI.getTemplates(self.templateType + "?" + queryString).then(result => {
                            var responseData = {
                                totalCount: 0,
                                data: []
                            };
                            responseData.totalCount = result.page.totalElements;
                            if (result.data != null) {
                                responseData.data = result.data;
                                responseData.data.forEach(function (obj, index) {
                                    if (obj.lastUpdated == null) {
                                        obj.lastUpdated = ""
                                    }
                                    obj['createdString'] = obj['created'] != null ?
                                        Utils.getMomentDateString(obj['created']) : ''
                                    obj['lastUpdatedString'] = obj['lastUpdated'] != null ?
                                        Utils.getMomentDateString(obj['lastUpdated']) : ''

                                })
                            }
                            self.updateCall = true;
                            self.tableData = responseData.data;
                            return responseData;

                        });
                    } else {
                        self.filterActive = false;
                        let responseData = {
                            totalCount: self.filterData.length,
                            data: self.filterData
                        };
                        return responseData;
                    }
                },
                onAfterDataLoad: (start, limit) => {
                    self.updateTemplate();
                }
            });
        },
        setFilterDataInLocalStorage() {
            localStorage.setItem("EmailTemplateListPageSize", this.tableObj.tableContext.store.state.pageSize);
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_selectedCreatedBy",
                this.selectedCreatedBy
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_dataListName",
                this.templateListName
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_selectedUpdatedBy",
                this.selectedUpdatedBy
            );
        },
        redirectToCreateEmailTemplate() {
            let url = this.templateType == 'FORM' ? this.CONTEXT_PATH + '/design/formTemplates/new' : this.CONTEXT_PATH + '/design/emailTemplates/new';
            this.$router.push(url);
        },
        resetFilter() {
            this.updateCall = false;
            this.selectedCreatedByRef = "";
            this.selectedUpdatedByRef = "";
            this.selectedUpdatedBy = "";
            this.templateListNameRef = "";
            this.selectedCreatedBy = "";
            this.templateListName = "";
            this.filterCount = 0;
            this.resetSlimSelect()
            localStorage.clear();
            localStorage.setItem("showedBPMTour", "true");
            this.initTemplateTable();
            this.updateTemplate();
        },
    }
};
</script>

<style scoped></style>
